import React, { useEffect } from 'react';
import i18n from 'i18n-js';
import { FormControl, FormLabel, Typography } from '@material-ui/core';
import { Field, Form, Formik, useFormikContext } from 'formik';
import { useStyles } from '../styles';
import { CheckboxWithLabel } from 'formik-material-ui';

export interface RestaurantFeatures {
    workingHours: boolean;
    workAreas: boolean;
    qrCodes: boolean;
    priceLevels: boolean;
    menus: boolean;
    users: boolean;
}

interface FeaturesSelectorStepProps {
    onMountSubmit: (submitFn: () => void) => void;
    onSubmit: (values: RestaurantFeatures) => void;
}

export default function FeaturesSelectorStep(props: FeaturesSelectorStepProps): JSX.Element {
    const classes = useStyles();

    const initialValues: RestaurantFeatures = {
        workingHours: false,
        workAreas: false,
        qrCodes: false,
        priceLevels: false,
        menus: false,
        users: false,
    };
    return (
        <div className={classes.featuresSelectorContainer}>
            <Typography variant="h6" align="left">
                {i18n.t('common.selectDataToCopy')}
            </Typography>
            <Typography component="p" align="left" className={classes.featuresSelectorSubtitle}>
                {i18n.t('common.chooseDateShouldBeCopied')}
            </Typography>

            <Formik
                initialValues={initialValues}
                onSubmit={(values) => {
                    props.onSubmit(values);
                }}
            >
                <InnerForm {...props} />
            </Formik>
        </div>
    );

    function InnerForm(props: FeaturesSelectorStepProps): JSX.Element {
        const { submitForm, setFieldValue, values } = useFormikContext<RestaurantFeatures>();

        useEffect(() => {
            props.onMountSubmit(submitForm);
        }, [submitForm]);

        function handleFirstCheckboxChange(e: React.ChangeEvent<HTMLInputElement>) {
            const checked = e.target.checked;
            setFieldValue('menus', checked);
            if (checked && !values.workAreas) {
                setFieldValue('workAreas', true);
            }
        }

        return (
            <Form className={classes.slectorFormRoot}>
                <div className={classes.flexRowOnly}>
                    <FormControl component="fieldset" className={classes.formControl}>
                        <FormLabel
                            component="legend"
                            className={classes.featuresSelectorSectionTitle}
                        >
                            {i18n.t('restaurant.restaurantInfo')}
                        </FormLabel>
                        <Field
                            component={CheckboxWithLabel}
                            type="checkbox"
                            name="workingHours"
                            disabled={false}
                            Label={{ label: i18n.t('form.openingHours') }}
                        />
                        <Field
                            component={CheckboxWithLabel}
                            type="checkbox"
                            name="workAreas"
                            disabled={values.menus}
                            Label={{ label: i18n.t('restaurant.workAreas') }}
                        />
                        <Field
                            component={CheckboxWithLabel}
                            type="checkbox"
                            name="qrCodes"
                            disabled={false}
                            Label={{ label: i18n.t('restaurant.qrCodes') }}
                        />
                        <Field
                            component={CheckboxWithLabel}
                            type="checkbox"
                            name="priceLevels"
                            disabled={false}
                            Label={{ label: i18n.t('restaurant.priceLevels') }}
                        />
                    </FormControl>
                    <FormControl component="fieldset" className={classes.formControl}>
                        <FormLabel
                            component="legend"
                            className={classes.featuresSelectorSectionTitle}
                        >
                            {' '}
                            {i18n.t('navigationTabs.menuManagement')}
                        </FormLabel>
                        <Field
                            component={CheckboxWithLabel}
                            type="checkbox"
                            name="menus"
                            onChange={handleFirstCheckboxChange}
                            disabled={false}
                            Label={{ label: i18n.t('restaurant.menuIngredientsCategories') }}
                        />
                    </FormControl>
                    <FormControl component="fieldset" className={classes.formControl}>
                        <FormLabel
                            component="legend"
                            className={classes.featuresSelectorSectionTitle}
                        >
                            {i18n.t('navigationTabs.userManagement')}
                        </FormLabel>
                        <Field
                            component={CheckboxWithLabel}
                            type="checkbox"
                            name="users"
                            disabled={false}
                            Label={{ label: i18n.t('restaurant.restaurantUsers') }}
                        />
                    </FormControl>
                </div>
            </Form>
        );
    }
}
